import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from "./header.component";
import {SwitchOrganisationModalModule} from "../switch-organisation-modal/switch-organisation-modal.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from "../../app-routing.module";
import {BannerModule, KebabMenuModule} from '@xref/xref-lib';
import { LanguageMenuModule, ButtonModule } from '@xref/xref-lib';
import { TooltipModule } from "@xref/xref-lib";
import {AlertBannerModule} from "../../lib/alert-banner";
import {LoaderModule} from "../loader/loader.module";
import {G2FormsModalModule} from "../g2-forms-modal/g2-forms-modal.module";
import {GenerateReportModule} from "../generate-report/generate-report.module";
import {TalentPoolReportModalModule} from "../talent-pool-report-modal/talent-pool-report-modal.module";



@NgModule({
  declarations: [HeaderComponent],
  imports: [
    CommonModule,
    SwitchOrganisationModalModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    AlertBannerModule.forRoot(),
    BrowserAnimationsModule,
    NgbModule,
    AppRoutingModule,
    KebabMenuModule,
    LanguageMenuModule,
    ButtonModule,
    TooltipModule,
    LoaderModule,
    BannerModule,
    G2FormsModalModule,
    GenerateReportModule,
    TalentPoolReportModalModule
  ],
  exports: [HeaderComponent]
})
export class HeaderModule {
}
